import React, { useState, useEffect, useRef, useMemo } from "react";
import "./Timer.css";
import { socket, serverTime, socketConnect } from "../../../Utils/Socket";
import moment from "moment-timezone";
import { addTimer } from "../../../Utils/Redux/Store/Actions/timer";
import { connect } from "react-redux";
import { useTimerTick } from "./TimerContext";

const getTimeRemaining = (t) => {
  var seconds = ("0" + Math.floor((t / 1000) % 60)).slice(-2);
  var minutes = ("0" + Math.floor((t / 1000 / 60) % 60)).slice(-2);
  var hours = ("0" + Math.floor((t / (1000 * 60 * 60)) % 24)).slice(-2);
  var days = 0;
  if (Math.floor(t / (1000 * 60 * 60 * 24)).toString().length >= 2) {
    days = Math.floor(t / (1000 * 60 * 60 * 24));
  } else {
    days = ("0" + Math.floor(t / (1000 * 60 * 60 * 24))).slice(-2);
  }

  return {
    total: t,
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds,
  };
};

const mapStateToProps = (state) => {
  return {
    timer: state.Timer.timer || localStorage.getItem("prodtimer"),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeTimer: (value) => dispatch(addTimer(value)),
  };
};

const TimerComponent = (props) => {
  const { tick } = useTimerTick();
  const [gifKey, setGifKey] = useState(0);
  const [gifUrl, setGifUrl] = useState("/assets/images/timeExtended.gif");
  const gifRef = useRef(null);
  const closeDate = new Date(props.date_closed);
  const [navDetails, setNavDetails] = useState(
    JSON.parse(localStorage.getItem("nav_details")),
  );

  useEffect(() => {
    if (gifRef.current && props.bpop_belowfive) {
      const src = gifRef.current.src;
      gifRef.current.src = "";
      gifRef.current.src = src;
    }
  }, [props.bpop_belowfive, props.date_closed]);

  const isLessThanOrEqual48Hours = (dateClosed) => {
    const now = moment(serverTime);
    const buynowHours =
      Number(props?.buynow_hours) > 0
        ? Number(props?.buynow_hours)
        : Number(navDetails?.bddw_buy_it_now_time);

    const threshold = now.clone().add(buynowHours, "hours");
    const closedDate = moment(dateClosed);
    return closedDate.isSameOrBefore(threshold);
  };

  const checkThisWeekDate = (futureDate) => {
    const now = new Date();
    const sixDaysFifteenHours = 6 * 24 * 60 * 60 * 1000 + 15 * 60 * 60 * 1000;
    const futureTime = new Date(futureDate).getTime();
    const timeDifference = futureTime - now.getTime();
    return timeDifference <= sixDaysFifteenHours;
  };

  // Calculate timer values on each tick (shared across all timers)
  const timer = useMemo(() => {
    if (!props.date_closed || !moment(props.date_closed).isValid()) {
      return {
        timervalid: false,
        timer_id: 1,
        days: 0,
        seconds: 0,
        minutes: 0,
        hours: 0,
        future: false,
      };
    }

    let startDate = new Date(serverTime);
    let endDate = new Date(props.date_closed);
    let timerTime = endDate.getTime() - startDate.getTime();
    let future = false;

    if (props.date_added && moment(props.date_added).isValid()) {
      let addDate = new Date(props.date_added);
      if (addDate > startDate) {
        timerTime = addDate.getTime() - startDate.getTime();
        future = true;
      }
    }

    const t = getTimeRemaining(timerTime);

    if (t.total <= 0) {
      return {
        timervalid: false,
        timer_id: 1,
        days: 0,
        seconds: 0,
        minutes: 0,
        hours: 0,
        future: false,
        expired: true,
      };
    }

    return {
      timervalid: true,
      timer_id: 1,
      days: t.days,
      seconds: t.seconds,
      minutes: t.minutes,
      hours: t.hours,
      future: future,
      expired: false,
    };
  }, [tick, props.date_closed, props.date_added]);

  const isThisWeekDate = useMemo(() => {
    return checkThisWeekDate(props.date_closed);
  }, [tick, props.date_closed]);

  // Derive flags before publishing so the first update cannot enable bidding
  // for an upcoming lot, or carry flags over from the previous lot.
  const isExpired = !!timer.expired;
  const isFuture = !!timer.future;
  const isLessThan48Hours = isLessThanOrEqual48Hours(props.date_closed);

  // Publish for each lot, even when navigation keeps the same timer flags.
  useEffect(() => {
    if (props.setTimerState) {
      props.setTimerState(props.id, isExpired, isLessThan48Hours, isFuture);
    }
  }, [props.id, isExpired, isLessThan48Hours, isFuture]);

  // Update localStorage for timer state
  useEffect(() => {
    if (timer.timervalid) {
      if (props?.ta_type == "upcoming") {
        localStorage.setItem(`prodtimer_${props?.id}`, timer.future);
        localStorage.setItem(`prodtimer`, timer.future);
      } else {
        localStorage.setItem(`prodtimer_${props?.id}`, timer.future);
        localStorage.setItem(`prodtimer`, timer.future);
      }
      props.changeTimer(timer.future);
    }
  }, [props.id, timer.future, timer.timervalid]);

  return (
    <div>
      {props.market_status &&
      (props.market_status == "closed" || props.market_status == "sold") &&
      !props.show ? (
        <div>
          <h2 className="lot_closed">Lot Closed</h2>
        </div>
      ) : !timer.timervalid && !timer.expired ? (
        ""
      ) : socketConnect !== 0 ? (
        timer.timervalid && props.bpop_belowfive ? (
          <div
            className={
              isThisWeekDate && timer.timervalid && !timer.future
                ? props.list_view === 1
                  ? "thisWeekTimerList"
                  : "thisWeekTimer"
                : ""
            }
          >
            <small style={{ color: "red" }}>
              {timer.future ? (
                "Starts In :"
              ) : props.bpop_belowfive ? (
                <img
                  ref={gifRef}
                  key={gifKey}
                  src={gifUrl}
                  className="timeExtended timeExtendedGrid"
                  alt="*** TIME EXTENDED ***"
                />
              ) : isThisWeekDate ? (
                <b
                  style={{
                    display: "inline-block",
                    textAlign: "center",
                    fontWeight: "bolder",
                  }}
                >
                  CLOSING SOON - {closeDate.getMonth() + 1}/
                  {closeDate.getDate()}
                </b>
              ) : (
                <b
                  style={{
                    display: "inline-block",
                    textAlign: "center",
                    fontWeight: "bolder",
                  }}
                >
                  CLOSING {closeDate.getMonth() + 1}/{closeDate.getDate()}
                </b>
              )}
            </small>

            {props.onlyGif ? (
              ""
            ) : (
              <div className={`timer ${props.className}`}>
                <div className="ext_bidding">
                  {timer.days} <b style={{ color: "red" }}>DAYS</b>
                </div>
                <div className="ext_bidding">
                  {timer.hours} <b style={{ color: "red" }}>HOUR</b>
                </div>
                <div className="ext_bidding">
                  {timer.minutes} <b style={{ color: "red" }}>MINUTES</b>
                </div>
                <div className="ext_bidding">
                  {timer.seconds} <b style={{ color: "red" }}>SECONDS</b>
                </div>
              </div>
            )}
          </div>
        ) : timer.timervalid ? (
          <div
            className={
              isThisWeekDate && timer.timervalid && !timer.future
                ? props.list_view === 1
                  ? "thisWeekTimerList"
                  : "thisWeekTimer"
                : ""
            }
          >
            {timer.future ? (
              <small>Starts In :</small>
            ) : props.bpop_belowfive ? (
              <img
                ref={gifRef}
                key={gifKey}
                src={gifUrl}
                className="timeExtended timeExtendedGrid"
                alt="*** TIME EXTENDED ***"
              />
            ) : isThisWeekDate ? (
              <b
                style={{
                  display: "inline-block",
                  textAlign: "center",
                  fontWeight: "bolder",
                }}
              >
                CLOSING SOON - {closeDate.getMonth() + 1}/{closeDate.getDate()}
              </b>
            ) : (
              <b
                style={{
                  display: "inline-block",
                  textAlign: "center",
                  fontWeight: "bolder",
                }}
              >
                CLOSING {closeDate.getMonth() + 1}/{closeDate.getDate()}
              </b>
            )}

            {props.onlyGif ? (
              ""
            ) : (
              <div
                className={`timer ${props.className} ${
                  props.bpop_belowfive ? "extendedTimedown" : ""
                }`}
              >
                <div>
                  {timer.days} <b>DAYS</b>
                </div>
                <div>
                  {timer.hours} <b>HOUR</b>
                </div>
                <div>
                  {timer.minutes} <b>MINUTES</b>
                </div>
                <div>
                  {timer.seconds} <b>SECONDS</b>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div>{/* <h2 className="lot_closed">Lot Closed</h2> */}</div>
        )
      ) : (
        <div>
          <h2 className="socket_disconnect">PLEASE REFRESH YOUR BROWSER</h2>
        </div>
      )}
    </div>
  );
};
const Timer = connect(mapStateToProps, mapDispatchToProps)(TimerComponent);
export default Timer;
